export const siteInfo = {
  name: '可游漫画网',
  tagline: '韩国漫画·无删减·下拉式阅读',
  description: '可游漫画网提供无删减韩国漫画下拉式阅读，韩漫在线免费阅读资源齐全且持续更新，从新作到经典应有尽有，满足多样化阅读喜好。',
  keywords: '韩国漫画,无删减漫画,下拉式漫画,韩漫在线免费阅读,可游漫画网,多样阅读喜好',
  url: 'https://szwlst.cn',
  email: 'contact@keyoumanhua.com',
  phone: '400-123-4567',
  address: '中国北京市朝阳区望京SOHO T3',
  foundingYear: 2020,
  stats: {
    totalComics: 12580,
    totalChapters: 356000,
    dailyVisitors: 520000,
    registeredUsers: 8900000,
  },
  socialLinks: {
    weibo: 'https://weibo.com/keyoumanhua',
    wechat: 'keyoumanhua',
    bilibili: 'https://space.bilibili.com/keyoumanhua',
  },
  features: [
    { title: '无删减原版', description: '坚持提供无删减版本的韩国漫画，让读者体验原汁原味的韩漫内容，不经过任何删改处理。', icon: 'ri-check-double-line' },
    { title: '下拉式阅读', description: '专为移动端优化的下拉式阅读体验，无需翻页，流畅滑动即可沉浸式阅读，适配各种屏幕尺寸。', icon: 'ri-scroll-to-bottom-line' },
    { title: '免费阅读', description: '所有漫画内容完全免费，无需付费订阅，让每一位韩漫爱好者都能无障碍享受阅读乐趣。', icon: 'ri-money-cny-circle-line' },
    { title: '持续更新', description: '与韩国原作同步更新，每日数十部漫画更新，确保读者第一时间看到最新章节内容。', icon: 'ri-refresh-line' },
    { title: '资源齐全', description: '收录超过12000部韩国漫画，涵盖恋爱、动作、奇幻、悬疑等全品类，新作经典一应俱全。', icon: 'ri-stack-line' },
    { title: '高清画质', description: '提供高清原画画质，细节清晰可见，完美呈现韩国漫画精美的绘画风格和色彩表现。', icon: 'ri-hd-line' },
  ],
  faqs: [
    {
      question: '可游漫画网上的漫画真的完全免费吗？',
      answer: '是的，可游漫画网上所有韩国漫画内容完全免费阅读，无需任何付费订阅或购买。我们通过广告收入维持网站运营，致力于为韩漫爱好者提供无障碍的阅读体验。',
    },
    {
      question: '网站上的漫画是否包含删减内容？',
      answer: '我们始终坚持提供无删减版本的韩国漫画。所有内容均来自韩国官方原作，不做任何形式的删改处理，确保读者能够体验到原汁原味的韩漫故事。',
    },
    {
      question: '什么是下拉式阅读模式？',
      answer: '下拉式阅读是针对移动端优化的阅读方式，读者只需向下滑动屏幕即可连续阅读，无需点击翻页按钮。这种方式更适合手机和平板设备，提供流畅的沉浸式阅读体验。',
    },
    {
      question: '漫画更新频率是怎样的？',
      answer: '我们每天都会更新数十部漫画的最新章节，与韩国原作保持同步。热门连载作品通常在韩国更新后24小时内即可在可游漫画网上阅读到最新内容。',
    },
    {
      question: '如何找到我想看的漫画？',
      answer: '您可以通过首页的搜索功能直接搜索漫画名称，也可以通过分类页面按类型浏览。我们还设有推荐榜单和最新更新板块，帮助您发现更多优质韩漫作品。',
    },
    {
      question: '支持哪些设备阅读？',
      answer: '可游漫画网采用响应式设计，完美适配电脑、平板和手机等各种设备。无论您使用什么设备，都能获得最佳的阅读体验。',
    },
  ],
  testimonials: [
    {
      name: '小雨',
      role: '资深韩漫读者',
      content: '从2021年开始用可游漫画网，资源真的太全了！很多在其他平台找不到的冷门韩漫这里都有，而且更新速度特别快，强烈推荐！',
      avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20woman%20anime%20style%20portrait%2C%20soft%20warm%20lighting%2C%20gentle%20smile%2C%20simple%20clean%20background%2C%20flat%20illustration%20style%2C%20cute%20casual%20look&width=120&height=120&seq=avatar-01&orientation=squarish',
    },
    {
      name: '阿杰',
      role: '漫画博主',
      content: '作为一个做了5年韩漫推荐的博主，可游漫画是我最常用的平台之一。无删减真的很重要，很多作品的精髓都在细节里，这里完全保留了下来。',
      avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20man%20anime%20style%20portrait%2C%20soft%20warm%20lighting%2C%20friendly%20expression%2C%20simple%20clean%20background%2C%20flat%20illustration%20style%2C%20smart%20casual%20look&width=120&height=120&seq=avatar-02&orientation=squarish',
    },
    {
      name: '小鹿',
      role: '学生读者',
      content: '作为学生党，免费对我来说太重要了！可游漫画网不仅免费，画质还特别清晰，下拉式阅读在手机上体验超级好，每天睡前必刷。',
      avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20girl%20anime%20style%20portrait%2C%20soft%20warm%20lighting%2C%20sweet%20smile%2C%20simple%20clean%20background%2C%20flat%20illustration%20style%2C%20student%20look&width=120&height=120&seq=avatar-03&orientation=squarish',
    },
  ],
};